/** @format */

// import swal from "../reusables/CustomSwal";

export default class APIRequest {
  static set = async (endpoint, method, body) => {
    // console.log(localStorage.token)

    // let token = localStorage.token;
    let request = {
      method: method,
      headers: {
        "Content-Type": "application/json",
        // Authorization: token ? `bearer ${token}` : null,
        Accept: "application/json",
      },
      body: JSON.stringify(body),
    };

    console.log(`[${method}] ${process.env.REACT_APP_API_ONX + endpoint}`);

    let response = await fetch(
      process.env.REACT_APP_API_ONX + endpoint,
      request
    );
    if (response.ok) {
      return response.json();
    }

    let error = await response.json();
    console.log(error);

    if (
      error.code === "JWT_EXPIRED" ||
      error.code === "NO_SECRET_DEFINED" ||
      error.code === "NO_TOKEN_PROVIDED" ||
      error.code === "BAD_TOKEN_FORMAT" ||
      error.code === "NO_USER_DATA" ||
      error.code === "NO_MEMBER_DATA" ||
      error.code === "NO_ADMIN_DATA" ||
      error.code === "NO_SUPER_ADMIN_DATA"
    ) {
      // await swal.fire({
      //   title: "Error",
      //   text: "An error has occurred. Please re-login.",
      //   icon: "error",
      //   confirmButtonText: "Ok",
      // });
      await localStorage.clear();
      console.log("Token deleted");
      // window.location.reload();
    }
    throw error;
  };

  static setFile = async (endpoint, method, file) => {
    // console.log(localStorage.token)

    // let token = localStorage.token;
    let request = {
      method: method,
      headers: {
        "Content-Type": file.type,
        // Authorization: token ? `bearer ${token}` : null,
        Accept: "application/json",
      },
      body: file,
    };

    console.log(`[${method}] ${process.env.REACT_APP_API_ONX + endpoint}`);

    let response = await fetch(
      process.env.REACT_APP_API_ONX + endpoint,
      request
    );
    if (response.ok) {
      return response.json();
    }

    let error = await response.json();
    console.log(error);

    if (
      error.code === "JWT_EXPIRED" ||
      error.code === "NO_SECRET_DEFINED" ||
      error.code === "NO_TOKEN_PROVIDED" ||
      error.code === "BAD_TOKEN_FORMAT" ||
      error.code === "NO_USER_DATA" ||
      error.code === "NO_MEMBER_DATA" ||
      error.code === "NO_ADMIN_DATA" ||
      error.code === "NO_SUPER_ADMIN_DATA"
    ) {
      // await swal.fire({
      //   title: "Error",
      //   text: "An error has occurred. Please re-login.",
      //   icon: "error",
      //   confirmButtonText: "Ok",
      // });
      await localStorage.clear();
      console.log("Token deleted");
      // window.location.reload();
    }
    throw error;
  };

  static setMultipart = async (endpoint, method, body) => {
    // let token = localStorage.token;

    let response = await fetch(process.env.REACT_APP_API_ONX + endpoint, {
      method: method,
      headers: {
        // Authorization: token ? `bearer ${token}` : null,
        // "Access-Control-Allow-Origin": "*",
      },
      body: body,
    });
    if (response.ok) {
      return response.json();
    } else {
      let error = await response.json();
      console.log(error);
      throw error;
    }
  };
}
